"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // 1177. Curs Grupal Competencial - Preparació Entrevista Mossos (02/05/2026)
    {
        id: 1177,
        tax: 0.0,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA), al tratarse de una formación homologada por una entidad oficial.",
        category: [
            product_types_1.Category.Interviews,
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.FASE2,
        ],
        sku: "iopos.course.f2f.curs-grupal-competencial-prep-entrevista-mossos-02_05_2026",
        title: "Curs Grupal Competencial - Preparació Entrevista Mossos (02/05/2026)",
        name: "Curs Grupal Competencial - Preparació Entrevista Mossos (02/05/2026)",
        description: "Entrena les competències que realment s'avaluen a l'entrevista de Mossos i aprèn a convertir les teves experiències en respostes sòlides i convincents.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/1177/image1"],
        banner: ["/1177/image1"],
        link: "/tienda/cursos/curs-grupal-competencial-preparacio-entrevista-mossos-02-05-2026/",
        created_at: "2026-03-30 00:00:01",
        start_at: "2026-03-30 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
    },
    // 1178. Curs Online Policia Local de Terrrassa
    {
        id: 1178,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-policia-local-terrassa-2026",
        title: "Curs Online Policia Municipal de Terrassa (2026)",
        name: "Curs Online Policia Municipal de Terrassa (2026)",
        description: "Prepara l'oposició de Policia Municipal de Terrassa amb un curs complet, actualitzat i pensat perquè arribis a l'examen amb seguretat.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 29.99,
        offer: 79.99,
        offer_message: "Oferta exclusiva!",
        offer_text: "Oferta exclusiva!",
        shipment: 0.0,
        images: ["/1178/image1"],
        banner: ["/1178/image1"],
        link: "/tienda/cursos/curs-online-policia-municipal-terrassa-2026/",
        created_at: "2026-03-05 00:00:01",
        start_at: "2026-03-05 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1249,
            group_id: [3106],
        },
        availableUntilExam: true,
    },
    // 1179. Curs Intensiu Català C1 Online 2026
    {
        id: 1179,
        tax: 0.21,
        sku: "iopos.course.online.curs-intensiu-catala-c1-online-2026",
        title: "Curs Intensiu Català C1 Online (accés campus durant 60 dies) 2026",
        name: "Curs Intensiu Català C1 Online (accés campus durant 60 dies) 2026",
        category: [
            product_types_1.Category.PL,
            product_types_1.Category.Mossos,
            product_types_1.Category.GUB,
            product_types_1.Category.Others,
            product_types_1.Category.Online,
        ],
        description: "Prepara el C1 de català en només 2 mesos amb un curs pràctic, flexible i orientat a superar l'examen.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/1179/image1"],
        banner: ["/1179/image1"],
        link: "/tienda/cursos/curs-intensiu-catala-c1-online-2026/",
        created_at: "2026-03-13 00:00:07",
        start_at: "2026-03-13 00:00:07",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: {
            course_id: 1255,
            group_id: [3121],
        },
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "Curs Intensiu Català C1 Online",
            secondTitle: "Metodologia pràctica i flexible",
            thirdTitle: "Prepara el **C1 de català** en només **2 mesos** amb un **curs pràctic**, **flexible** i orientat a **superar l'examen**.",
            landscape: "/1179/hero_h",
            portrait: "/1179/hero_v",
        },
    },
    // 1180. Curs Online Intensiu Actic (Nivell Mitjà) 2026
    {
        id: 1180,
        tax: 0.21,
        sku: "iopos.course.curs-online-intensiu-actic-nivell-mitja-2026",
        title: "Curs Online Intensiu ACTIC Nivell Mitjà 2026 (accés campus durant 90 dies)",
        name: "Curs Online Intensiu ACTIC Nivell Mitjà 2026 (accés campus durant 90 dies)",
        category: [product_types_1.Category.Others, product_types_1.Category.Online],
        description: "Aconsegueix l'ACTIC nivell mitjà i suma punts a la teva oposició amb una preparació clara i efectiva.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/1180/image1.jpg"],
        banner: ["/1180/image1.jpg"],
        link: "/tienda/cursos/curs-online-intensiu-actic-nivell-mitja-2026/",
        created_at: "2026-03-13 00:00:07",
        start_at: "2026-03-13 00:00:07",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: {
            course_id: 492,
            group_id: [3124],
        },
        can_be_sent: false,
        items: 1,
        hero: {
            firstTitle: "Curs Online Intensiu ACTIC Nivell Mitjà",
            secondTitle: "Amb accés al campus",
            thirdTitle: "**Aconsegueix l'ACTIC nivell mitjà** i suma punts a la teva oposició amb una preparació **clara i efectiva**.",
            landscape: "/807/hero_h",
            portrait: "/807/hero_v",
        },
    },
    // 1181. Curs Presencial ACTIC nivell mitjà (10 h) - Edició #2: 28 i 29 d'abril 2026
    {
        id: 1181,
        category: [product_types_1.Category.FaceToFace, product_types_1.Category.Others],
        type: product_types_1.Type.Course,
        tax: 0.0,
        sku: "iopos.course.f2f.2025-curs-presencial-actic-nivell-mitja-14h-28-29-abr-2026",
        title: "Curs Presencial ACTIC nivell mitjà (14 h - 28 i 29 d'abril de 10:00 a 17:00 h)",
        name: "Curs Presencial ACTIC nivell mitjà (14 h - 28 i 29 d'abril de 10:00 a 17:00 h)",
        short: "2.) Curs ACTIC nivell mitjà (28 i 29 d'abril de 10:00 - 17:00)",
        description: "Aconsegueix el certificat ACTIC nivell mitjà en només 3 dies amb el nostre curs intensiu i presencial. Ràpid, efectiu i amb suport personalitzat!",
        enabled: false,
        stock: false,
        stock_message: "Aviat disponible!",
        price: 89.99,
        shipment: 0.0,
        images: ["/807/image2"],
        banner: ["/807/image2"],
        link: "/tienda/cursos/curs-presencial-actic-nivell-mitja-14-hores-2025-28-29-abril/",
        created_at: "2026-03-13 00:00:01",
        start_at: "2026-03-13 00:00:01",
        more_info: false,
        can_be_sent: false,
        items: 1,
        limit: 30,
        parent: 807,
        evolmind: { course_id: 492, group_id: [3118] },
    },
    // 1182. Fase 4: Mataró - Simulacre d'Entrevista Duo Mossos d'Esquadra 2026 (1:00 hora)
    {
        id: 1182,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE4,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.fase4-simulacre-entrevista-duo-policial-mossos-2026-1h-mataro",
        title: "Fase 4: Mataró - Simulacre d'Entrevista Duo Mossos d'Esquadra 2026 (1:00 h)",
        name: "Fase 4: Mataró - Simulacre d'Entrevista Duo Mossos d'Esquadra 2026 (1:00 h)",
        description: "Una doble avaluació professional que et permet saber exactament com rendiries davant el tribunal real.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        // low_stock_message: "Últimes places disponibles!",
        special_buy: "/tienda/cursos/fase4-mataro-simulacre-dentrevista-duo-mossos-2026-1h/#reserva",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 189.99,
        shipment: 0.0,
        images: ["/1182/image1_h"],
        banner: ["/1182/image1_h"],
        link: "/tienda/cursos/fase4-mataro-simulacre-dentrevista-duo-mossos-2026-1h/",
        created_at: "2026-03-13 00:00:01",
        start_at: "2026-03-13 00:00:01",
        more_info: true,
        items: 1,
        calendly_schedule: [
            {
                id: 1,
                name: "Txema i Núria",
                position: "Agent CME  i Psicòloga",
                description: "Experiència combinada en avaluació i psicologia aplicada a processos selectius. Sessions dinàmiques, enfocades a potenciar habilitats i confiança davant el tribunal.",
                location: "ÀTIC Coworking Business Center, Carrer Balançó i Boter, 22, 08302 Mataró, Barcelona",
                link: "https://calendly.com/d/cxk2-8mk-q3p/fase-4-simulacre-entrevista-duo-mossos-2026-1h-ma",
            },
        ],
    },
    // 1183. Pensar com un Caporal: Casos Pràctics i criteri professional (2026 edició)
    {
        id: 1183,
        tax: 0.04,
        sku: "iopos.book.pensar-com-un-caporal-casos-practics-criteri-pro-2026-ed1",
        title: "Pensar com un Caporal: Casos pràctics i criteri professional",
        name: "Pensar com un Caporal: Casos pràctics i criteri professional",
        description: "Aprèn a pensar, decidir i liderar com un caporal amb casos reals i criteri professional.",
        enabled: true,
        stock: true,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.CP],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Oferta de llançament!",
        shipment: 0.0,
        images: ["/1183/image1"],
        banner: ["/1183/image1"],
        link: "/tienda/libros/pensar-com-un-caporal-casos-practics-i-criteri-professional/",
        created_at: "2026-03-24 00:00:09",
        start_at: "2026-03-24 00:00:09",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 490,
        productImage: {
            landscape: "/1183/image1.jpg",
            portrait: "/1183/image1.jpg",
        },
    },
    // 1184. Curs Online Policia Local de Mataró (2026)
    {
        id: 1184,
        tax: 0.21,
        category: [product_types_1.Category.Online, product_types_1.Category.PL],
        sku: "iopos.course.online.curs-online-policia-local-mataro-2026",
        title: "Curs Online Policia Local de Mataró (2026)",
        name: "Curs Online Policia Local de Mataró (2026)",
        description: "Dona el pas definitiu cap a la teva plaça de Policia Local de Mataró amb una preparació completa, pràctica i pensada per obtenir resultats.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 19.99,
        offer: 79.99,
        offer_message: "Oferta exclusiva!",
        offer_text: "Oferta exclusiva!",
        shipment: 0.0,
        images: ["/1184/image_h"],
        banner: ["/1184/image_h"],
        link: "/tienda/cursos/curs-online-policia-local-mataro-2026/",
        created_at: "2026-03-22 00:00:01",
        start_at: "2026-03-22 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 1258,
            group_id: [3127],
        },
        hero: {
            firstTitle: "Curs Online Policia Local de Mataró",
            secondTitle: "Convocatòria 2026",
            thirdTitle: "**Dona el pas definitiu** cap a la teva **plaça de Policia Local de Mataró** amb una **preparació completa**, **pràctica** i pensada per **obtenir resultats**.",
            landscape: "/1184/hero_h",
            portrait: "/1184/hero_v",
        },
        availableUntilExam: true,
    },
    // 1185. Curs Semipresencial Homologat Dret Penal - 2026 (28 març)
    {
        id: 1185,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026",
        name: "Curs Homologat Semipresencial Dret Penal - 2026",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-2026/",
        created_at: "2026-03-23 00:00:01",
        start_at: "2026-03-23 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v",
            landscape: "/1185/image1_h",
        },
        hero: {
            // portrait: "/images/products/1185/hero_v.jpg",
            portrait: "/1185/hero_v",
            // landscape: "/images/products/1185/hero_h.jpg",
            landscape: "/1185/hero_h",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        childs: [1192, 1186, 1190, 1191, 1122, 1267],
    },
    // 1186. Curs Semipresencial Homologat Dret Penal - 2026 (29 març)
    {
        id: 1186,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-29-marc-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026 (29 març)",
        name: "Curs Homologat Semipresencial Dret Penal - 2026 (29 març)",
        short: "2.) Curs Semipresencial Homologat Dret Penal (29 març 2026)",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-29-03-2026/",
        created_at: "2026-03-15 00:00:01",
        start_at: "2026-03-15 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 973,
            group_id: [3133],
        },
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v.jpg",
            landscape: "/1185/image1_h.jpg",
        },
        hero: {
            portrait: "/1185/hero_v.jpg",
            landscape: "/1185/hero_h.jpg",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        parent: 1185,
        default_in_parent: false,
    },
    // 1187. Curso Homologado Semipresencial Ley Orgánica 4 / 2015 (2026)
    {
        id: 1187,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-llei-organica-4-2015-4-hores-2026",
        title: "Curs Homologat Semipresencial Llei Orgànica 4/2015 - (2026)",
        name: "Curs Homologat Semipresencial Llei Orgànica 4/2015 - (2026)",
        description: "Domina la Llei de Seguretat Ciutadana i actua amb seguretat real en el servei i a les oposicions.",
        enabled: true,
        stock: true,
        stock_message: "Sense places",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1187/image1_h"],
        banner: ["/1187/image1_h"],
        link: "/tienda/cursos/curs-semipresencial-homologat-llei-organica-4-2015--2026/",
        created_at: "2026-03-23 00:00:01",
        start_at: "2026-03-23 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1187/image1_v.jpg",
            landscape: "/1187/image1_h.jpg",
        },
        hero: {
            portrait: "/1187/hero_v.jpg",
            landscape: "/1187/hero_h.jpg",
            firstTitle: "Curs Homologat Semipresencial Llei Orgànica 4/2015",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina la Llei de Seguretat Ciutadana** i actua amb **seguretat real** en el servei i a les **oposicions**.",
        },
        childs: [1188, 1189, 1123, 1244, 1265],
    },
    // 1188. Curso Homologado Semipresencial Ley Orgánica 4 / 2015 (2026) Grup 1 Matí
    {
        id: 1188,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-llei-organica-4-2015-4-hores-2026-25-abril-grup-mati",
        title: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 abril - matí 08:30 a 13:30)",
        name: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 abril - matí 08:30 a 13:30)",
        short: "1.) Curs Semipresencial Homologat Llei Orgànitca 4/2015 (25 abril - matí 08:30 a 13:30)",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1187/image1_h"],
        banner: ["/1187/image1_h"],
        link: "/tienda/cursos/curs-semipresencial-homologat-llei-organica-4-2015-2026/",
        created_at: "2026-03-17 00:00:01",
        start_at: "2026-03-17 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        parent: 1187,
        evolmind: {
            course_id: 1114,
            group_id: [3136],
        },
        productImage: {
            portrait: "/1187/image1_v.jpg",
            landscape: "/1187/image1_h.jpg",
        },
        default_in_parent: true,
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
    },
    // 1189. Curso Homologado Semipresencial Ley Orgánica 4 / 2015 (2026) Grup 2 Tarda
    {
        id: 1189,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-llei-organica-4-2015-4-hores-2026-25-abril-grup-tarda",
        title: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 abril - tarda 15:00 a 19:00)",
        name: "Curs Homologat Semipresencial Llei Orgànica 4/2015 (2026) (25 abril - tarda 15:00 a 19:00)",
        short: "2.) Curs Semipresencial Homologat Llei Orgànica 4/2015 (25 abril - tarda 15:00 a 19:00)",
        description: "",
        enabled: true,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1187/image1_h"],
        banner: ["/1187/image1_h"],
        link: "/tienda/cursos/curs-semipresencial-homologat-llei-organica-4-2015-2026/",
        created_at: "2026-03-17 00:00:01",
        start_at: "2026-03-17 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        parent: 1187,
        evolmind: {
            course_id: 1114,
            group_id: [3139],
        },
        productImage: {
            portrait: "/1187/image1_v.jpg",
            landscape: "/1187/image1_h.jpg",
        },
        homologated: [
            {
                code: "RP20250070869",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
    },
    // 1190. Curs Semipresencial Homologat Dret Penal - 2026 (9 maig)
    {
        id: 1190,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-9-maig-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026 (9 maig)",
        name: "Curs Homologat Semipresencial Dret Penal - 2026 (9 maig)",
        short: "3.) Curs Semipresencial Homologat Dret Penal (9 maig 2026)",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-29-03-2026/",
        created_at: "2026-03-15 00:00:01",
        start_at: "2026-03-15 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 973,
            group_id: [3142],
        },
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v",
            landscape: "/1185/image1_h",
        },
        hero: {
            portrait: "/1185/hero_v",
            landscape: "/1185/hero_h",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        parent: 1185,
    },
    // 1191. Curs Semipresencial Homologat Dret Penal - 2026 (10 maig)
    {
        id: 1191,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
            product_types_1.Category.Online,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-10-maig-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026 (10 maig)",
        name: "Curs Homologat Semipresencial Dret Penal - 2026 (10 maig)",
        short: "4.) Curs Semipresencial Homologat Dret Penal (10 maig 2026)",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-29-03-2026/",
        created_at: "2026-03-15 00:00:01",
        start_at: "2026-03-15 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 973,
            group_id: [3145],
        },
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v",
            landscape: "/1185/image1_h",
        },
        hero: {
            portrait: "/1185/hero_v",
            landscape: "/1185/hero_h",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        parent: 1185,
    },
    // 1192. Curs Semipresencial Homologat Dret Penal - 2026 (28 març)
    {
        id: 1192,
        tax_message: "Operación exenta de IVA según el artículo 20.uno.20º de la Ley 37/1992, de 28 de diciembre, del Impuesto sobre el Valor Añadido (IVA).",
        tax: 0.0,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Online,
            product_types_1.Category.ISPC,
            product_types_1.Category.PROTECCION_Y_ATENCION_A_LA_CIUDADANIA,
            product_types_1.Category.HOMOLOGADOS,
            product_types_1.Category.CURSOS_POLICIALES,
        ],
        sku: "iopos.course.f2f.curs-homologat-semipresencial-dret-penal-8-hores-28-marc-2026",
        title: "Curs Homologat Semipresencial Dret Penal - 2026 (28 març)",
        name: "Curs Homologat Semipresencial Dret Penal - 2026 (28 març)",
        short: "1.) Curs Homologat SemipresencialDret Penal (28 març 2026)",
        description: "Domina el Codi Penal amb una formació pràctica orientada a professionals dels cossos policials.",
        enabled: true,
        stock: false,
        stock_message: "Aviat disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 79.99,
        // offer: 79.99,
        // offer_message: "Oferta de llançament les 20 primeres matrícules!",
        // offer_text: "Oferta de llançament les 20 primeres matrícules!",
        shipment: 0.0,
        images: ["/1185/image1"],
        banner: ["/1185/image1"],
        link: "/tienda/cursos/curs-semipresencial-homologat-dret-penal-29-03-2026/",
        created_at: "2026-03-15 00:00:01",
        start_at: "2026-03-15 00:00:01",
        more_info: false,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        evolmind: {
            course_id: 973,
            group_id: [3130],
        },
        homologated: [
            {
                code: "RP20250071042",
                year: 2026,
                from: "Institut de Seguretat Pública de Catalunya (ISPC)",
                durationInHours: 26,
                description: "Aquest curs està homologat per **l'Institut de Seguretat Pública de Catalunya (ISPC)** com a activitat de formació contínua.",
                instructions: "Un cop superades totes les proves d'avaluació, l'alumnat obtindrà un **certificat d'aprofitament**, que serà emès i enviat posteriorment.",
                document: {
                    info: "Pots descarregar-te el document oficial del reconeixement de la nostra formació expedit per l'Institut de Seguretat Pública de Catalunya.",
                    url: "https://iopos.link/expedient-relatiu-al-reconeixement-d-activitats-de-formacio-continua-per-a-realitzar-l-any-2026",
                },
            },
        ],
        productImage: {
            portrait: "/1185/image1_v.jpg",
            landscape: "/1185/image1_h.jpg",
        },
        hero: {
            portrait: "/1185/hero_v.jpg",
            landscape: "/1185/hero_h.jpg",
            firstTitle: "Curs Homologat Semipresencial Dret Penal",
            secondTitle: "ISPC 2026",
            thirdTitle: "**Domina el Codi Penal** amb una formació pràctica orientada a **professionals dels cossos policials**.",
        },
        parent: 1185,
        default_in_parent: true,
    },
];
exports.default = products;
